import React, { useState } from "react";
import { FormFeedback, Input, Label } from "reactstrap";

export interface PasswordFieldProps {
    validation: any;
}
export const PasswordField: React.FC<PasswordFieldProps> = ({
    validation
}) => {
    const [password, setPassword] = useState<boolean>(true);
    const [eye, setEye] = useState<string>("bi bi-eye-slash");
    const [type, setType] = useState<any>("password");
    return (
        <React.Fragment>
            <Label className="form-label">Password</Label>
            <div className="input-group">
                <Input
                    name="password"
                    type={type}
                    className="form-control"
                    placeholder="Enter password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.password || ""}
                    invalid={
                        validation.touched.password && validation.errors.password ? true : false
                    }
                />
                <div className="input-group-append">
                    <button
                        type="button"
                        className={`btn btn-light rounded-0 rounded-end  ${eye}`}
                        onClick={() => {
                            if (password === true) {
                                setPassword(false);
                                setEye("bi bi-eye");
                                setType("text");
                            } else {
                                setPassword(true);
                                setEye("bi bi-eye-slash");
                                setType("password");
                            }
                        }}
                    />
                </div>
                {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                ) : null}
            </div>
        </React.Fragment>
    );
}
PasswordField.propTypes = {

};